import React from 'react';
import { Box, Text, VStack, Icon } from '@chakra-ui/react';
import { MdLock } from 'react-icons/md';
import { authService } from '../services/authService';

/**
 * RoleGuard Component
 * Belirli rollere göre içeriği gösterir veya gizler
 * 
 * @param {string} allowedRoles - İzin verilen roller ('manager', 'staff', 'business')
 * @param {boolean} requireAll - Tüm rollere mi ihtiyaç var (default: false, OR mantığı)
 * @param {ReactNode} children - Gösterilecek içerik
 * @param {ReactNode} fallback - Yetki yoksa gösterilecek içerik (opsiyonel)
 */
export const RoleGuard = ({ 
  allowedRoles = ['manager'], 
  requireAll = false,
  children, 
  fallback = null 
}) => {
  const currentUser = authService.getCurrentUser();
  const userRole = currentUser?.role || (currentUser?.userType === 'business' ? 'manager' : null);
  const userType = currentUser?.userType || 'business';

  // Business user'lar her zaman manager olarak kabul edilir
  const effectiveRole = userType === 'business' ? 'manager' : userRole;

  // Role kontrolü
  const hasAccess = requireAll
    ? allowedRoles.every(role => effectiveRole === role)
    : allowedRoles.includes(effectiveRole);

  if (!hasAccess) {
    if (fallback !== null) {
      return <>{fallback}</>;
    }
    
    // Erişim yoksa hiçbir şey gösterme (mesaj kaldırıldı)
    return null;
  }

  return <>{children}</>;
};

/**
 * ManagerOnly Component
 * Sadece manager'lar için içerik gösterir
 */
export const ManagerOnly = ({ children, fallback = null }) => {
  return (
    <RoleGuard allowedRoles={['manager']} fallback={fallback}>
      {children}
    </RoleGuard>
  );
};

/**
 * StaffOnly Component
 * Sadece staff'lar için içerik gösterir
 */
export const StaffOnly = ({ children, fallback = null }) => {
  return (
    <RoleGuard allowedRoles={['staff']} fallback={fallback}>
      {children}
    </RoleGuard>
  );
};

export default RoleGuard;

